import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AccountBalance } from "@mui/icons-material";
import { Fragment } from "react";
import { PageHeader } from "@/shared/components/PageHeader";
import {
  InstitutionDocument,
  InstitutionQuery,
  InstitutionQueryVariables,
  InstitutionsPageDataQuery,
  useInstitutionQuery,
  useInstitutionsPageDataQuery,
} from "@/services/graphql/reactQuery";
import { fetchData } from "@/services/graphql/queryUtil";
import { LoadingPageComponent } from "@/shared/components/LoadingPage";
import { PageContentContainer } from "@/shared/components/PageContentContainer";
import { InstitutionProfile } from "@/shared/components/Institution/InstitutionProfile";

interface LoaderData {
  institutionName?: string;
}

export const Route = createFileRoute("/institutions/$id")({
  component: RouteComponent,
  // loader: async ({ params, context }): Promise<LoaderData> => {
  //   // Synchronous cache hit — populated when coming from the list page
  //   const cached = context.queryClient.getQueryData<InstitutionsPageDataQuery>(
  //     useInstitutionsPageDataQuery.getKey()
  //   );
  //   const fromCache = cached?.getMarketplaceInstitutions.find(
  //     (i) => i.id?.toString() === params.id
  //   );
  //
  //   if (fromCache) return { institutionName: fromCache.name };
  //
  //   // Cache miss — fetch just this institution (direct URL / refresh)
  //   const data = await context.queryClient.fetchQuery({
  //     queryKey: useInstitutionQuery.getKey({ institutionId: Number(params.id) }),
  //     queryFn: () =>
  //       fetchData<InstitutionQuery, InstitutionQueryVariables>(
  //         InstitutionDocument,
  //         context.auth.tokenProvider
  //       )({ institutionId: Number(params.id) }),
  //   });
  //   return { institutionName: data.getMarketplaceInstitution?.name };
  // },
  // pendingComponent: LoadingPageComponent,
  // pendingMs: 0,
  // staticData: {
  //   breadcrumb: {
  //     icon: AccountBalance,
  //     title: ({ params: params, loaderData }) => {
  //       return (loaderData as LoaderData).institutionName ?? params.id;
  //     },
  //   },
  // },
});

function RouteComponent() {
  const { id } = Route.useParams();
  // const { institutionName } = Route.useLoaderData();

  const nav = useNavigate();

  return (
    <Fragment>
      {/*<PageHeader title={institutionName ?? ""} />*/}
      <PageContentContainer>
        <InstitutionProfile
          institutionId={Number(id)}
          errorConfig={{
            header: "Institution Not Found",
            actionLabel: "Return to Institutions List",
            onAction: () => nav({ to: "/institutions" }),
          }}
        />
      </PageContentContainer>
    </Fragment>
  );
}
